var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column-format centered",staticStyle:{"width":"100%","height":"100%"}},[_c('div',{staticClass:"brand-medium font-24"},[_vm._v(_vm._s(_vm.$t('subscriptions.hang-tight')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }